import { Controller } from '@hotwired/stimulus';
import Clipboard from "clipboard";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        title: String,
        url: String,
    };

    connect() {
        if (navigator.share) {
            this.element.style.removeProperty('display');
        }
    }

    share() {
        if (navigator.share) {
            navigator.share({
                title: this.titleValue,
                url: this.urlValue,
            }).catch(console.error);
        }
    }
}
